import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconUpload = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.48687 1.5798C8.29161 1.38453 7.97503 1.38453 7.77976 1.5798L4.77976 4.5798C4.5845 4.77506 4.5845 5.09164 4.77976 5.2869C4.97503 5.48217 5.29161 5.48217 5.48687 5.2869L7.63332 3.14046V10.7334C7.63332 11.0095 7.85717 11.2334 8.13332 11.2334C8.40946 11.2334 8.63332 11.0095 8.63332 10.7334V3.14046L10.7798 5.2869C10.975 5.48217 11.2916 5.48217 11.4869 5.2869C11.6821 5.09164 11.6821 4.77506 11.4869 4.5798L8.48687 1.5798ZM1.56665 14.0667C1.56665 13.7905 1.79051 13.5667 2.06665 13.5667H14.0667C14.3428 13.5667 14.5667 13.7905 14.5667 14.0667C14.5667 14.3428 14.3428 14.5667 14.0667 14.5667H2.06665C1.79051 14.5667 1.56665 14.3428 1.56665 14.0667Z",
        fill: "black"
    }));

export { IconUpload };
